import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

export default class ResultsList extends PaginatedList {
  layoutRequest = 0;
  connectedCallback() {
    super.connectedCallback();
    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.#restoreLayout();
    this.setAttribute('initialized', '');
  }
  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
  }
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement) || !this.contains(target)) return;
    if (!this.#valid(target.value)) return;
    this.#animateLayoutChange(target.value);
  }
  #valid(value) {
    return (mediaQueryLarge.matches ? ['default', 'zoom-out'] : ['default', 'mobile-single']).includes(value);
  }
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('product-grid-view', value);
    const name = mediaQueryLarge.matches ? 'grid' : 'grid-mobile';
    this.querySelectorAll('input.column-options__option-input').forEach(input => {
      if (input.name === name) input.checked = input.value === value;
    });
  }
  #restoreLayout() {
    const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
    let value = this.refs.grid?.getAttribute('product-grid-view') || 'default';
    try { value = sessionStorage.getItem('product-grid-view-' + viewport) || 'default'; }
    catch { /* Storage may be unavailable; the controls must still work. */ }
    this.#setLayout(this.#valid(value) ? value : 'default');
  }
  #animateLayoutChange = async (value) => {
    const request = ++this.layoutRequest;
    if (!this.refs.grid) return;
    await startViewTransition(() => { if (request === this.layoutRequest) this.#setLayout(value); }, ['product-grid']);
    requestIdleCallback(() => {
      if (request !== this.layoutRequest || !this.#valid(value)) return;
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      try { sessionStorage.setItem('product-grid-view-' + viewport, value); }
      catch { /* The selected layout still applies without session storage. */ }
    });
  };
  #handleMediaQueryChange = () => { this.layoutRequest++; this.#restoreLayout(); };
}
if (!customElements.get('results-list')) customElements.define('results-list', ResultsList);

